import { includes, map } from 'ramda';
import { isNilOrEmpty } from 'ramda-extension';

import { instrumentTypes } from '@gef-ui/apm/instruments/constants';

export const breadcrumbsOptions = {
	[instrumentTypes.REDUX]: (event) => {
		if (isNilOrEmpty(event)) {
			return event;
		}
		let payload = event.description?.payload;
		if (event.description?.type === 'BATCHING_REDUCER.BATCH') {
			payload = map((action) => {
				if (includes(action.type, ['SAVE_DELEGATIONS', 'MERGE_APP_CONTEXT'])) {
					return {
						...action,
						payload: '<truncated>',
					};
				}
				return action;
			}, event.description?.payload || []);
		}
		return Object.assign({}, { ...event, description: { ...event.description, payload } });
	},
};
